import { createFileRoute } from '@tanstack/react-router';
import { ImportacaoWizard } from '../components/financeiro/ImportacaoWizard';

export const Route = createFileRoute('/w/$workspaceId/financeiro/importacao')({
  component: ImportacaoPage,
});

function ImportacaoPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="mx-auto max-w-3xl space-y-5 rounded-2xl border-0 bg-[#FFFFFF] p-5 shadow-[0_0_15px_rgba(0,0,0,0.05)] outline-none ring-0 dark:bg-card dark:shadow-[0_0_15px_rgba(0,0,0,0.05)] sm:p-6 md:p-6">
      <div className="min-w-0">
        <h2 className="font-sans text-base font-normal tracking-normal text-[#06141B] dark:text-foreground">
          Importação de lançamentos
        </h2>
        <p className="mt-1 max-w-2xl font-sans text-xs font-normal text-[#9BA8AB] dark:text-muted-foreground">
          Envie arquivos CSV para registrar lotes de lançamentos com rastreabilidade (origem importação).
        </p>
      </div>
      <ImportacaoWizard workspaceId={workspaceId} />
    </div>
  );
}
